export default function Footer() {
  return (
    <footer className="bg-[#D0A24F] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* About */}
          <div>
            <h4 className="text-xl font-bold mb-6">
              <a href="#home" className="hover:text-white/90 transition-colors">
                Beaulieu Dental Chelmsford
              </a>
            </h4>
            <p className="text-white/90 mb-4 leading-relaxed">
              Leading <strong>private dentist in Chelmsford Essex</strong> specializing in <strong>dental implants</strong>, <strong>All on 4</strong>, <strong>Invisalign</strong>, and comprehensive dental care for <strong>anxious dental patients</strong>.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-xl font-bold mb-6">
              <a href="#implant-types" className="hover:text-white/90 transition-colors">
                Our Dental Services
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#implant-types" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Dental Implants Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#implant-types" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>All on 4 Dental Implants</strong>
                </a>
              </li>
              <li>
                <a href="#implant-types" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Smile in a Day</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Invisalign Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Composite Bonding Essex</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Teeth Whitening Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Root Canal Treatment</strong>
                </a>
              </li>
            </ul>
          </div>

          {/* Additional Services */}
          <div>
            <h4 className="text-xl font-bold mb-6">
              <a href="#treatments" className="hover:text-white/90 transition-colors">
                More Services
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Ceramic Veneers Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Dentures Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>EMS Airflow Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Dental Hygienist Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Dental Sedation Chelmsford</strong>
                </a>
              </li>
              <li>
                <a href="#treatments" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Wisdom Teeth Extraction</strong>
                </a>
              </li>
              <li>
                <a href="#nervous-patients" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  <strong>Anxious Dental Patients Care</strong>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6">
              <a href="#contact" className="hover:text-white/90 transition-colors">
                Contact Us
              </a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl mt-1 flex-shrink-0"></i>
                <span className="text-white/90">
                  Beaulieu Park<br />
                  Chelmsford, Essex<br />
                  CM1 6GZ
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-xl flex-shrink-0"></i>
                <a href="tel:01245465586" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  01245 465586
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-xl flex-shrink-0"></i>
                <a href="mailto:info@beaulieudental.co.uk" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  info@beaulieudental.co.uk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Our Policies */}
        <div className="border-t border-white/20 pt-8 mb-8">
          <div className="text-center">
            <h4 className="text-xl font-bold mb-4">Our Policies</h4>
            <a 
              href="https://beaulieudental.co.uk/policies/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/90 hover:text-white transition-colors cursor-pointer text-base"
            >
              <i className="ri-file-text-line text-xl"></i>
              View Our Practice Policies
              <i className="ri-external-link-line text-lg"></i>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/80 text-sm text-center md:text-left">
              © 2025 Beaulieu Dental Chelmsford. All rights reserved. | <strong>Dental Implants in Chelmsford Essex</strong> | <strong>Diamond Invisalign Provider</strong>
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
